import { rect, px } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const slime: Hull = {
  id: 'slime',
  name: 'Slime',
  baseStats: { ferocity: 5, agility: 15, arcane: 10, resilience: 35, stealth: 25 },
  drawBody: (ctx, p, t = 0) => {
    const frame = Math.floor((t * 4) % 2);
    const yTop = 30 + frame;

    // Main blob body — hemispherical, wider at base
    rect(ctx, 16, yTop + 4, 32, 16, p.primary);
    // Tapered top (top edge curves)
    rect(ctx, 18, yTop + 2, 28, 2, p.primary);
    rect(ctx, 22, yTop, 20, 2, p.primary);
    rect(ctx, 26, yTop - 2, 12, 2, p.primary);
    // Top edge highlight
    rect(ctx, 26, yTop - 2, 12, 1, p.glassLight);
    rect(ctx, 22, yTop, 20, 1, p.glassLight);
    // Bottom rim shadow (frame-independent)
    rect(ctx, 16, 46, 32, 4, p.shadow);
    // Eyes (frame-independent — at fixed y, doesn't jiggle)
    rect(ctx, 24, 38, 3, 3, p.glassLight);  // left eye white
    rect(ctx, 37, 38, 3, 3, p.glassLight);  // right eye white
    px(ctx, 25, 39, p.detail);              // left pupil
    px(ctx, 38, 39, p.detail);              // right pupil
    px(ctx, 25, 39, p.dark);                // left pupil center
    px(ctx, 38, 39, p.dark);                // right pupil center
  },
  mounts: {
    [SLOT.CRANIUM]: { anchor: { x: 32, y: 30 } },
    [SLOT.BACK]:    { anchor: { x: 24, y: 38 } },
    [SLOT.TAIL]:    { anchor: { x: 48, y: 42 } },
  },
};
